import React from "react";
import {
    FileTextOutlined,
    TagOutlined,
    MessageOutlined,
    InfoCircleOutlined
} from "@ant-design/icons";
import { Col, Row } from "antd";
import CommonCard from "../../../global/card";
import { cn } from "../../../../utils/cn";

const EnhancedAutorespondersDetails = ({ data }) => {
    if (!data) return null;

    const getIconForField = (label) => {
        const iconMap = {
            "Internal Name": <TagOutlined />,
            "Display Title": <FileTextOutlined />,
        };
        return iconMap[label] || <FileTextOutlined />;
    };

    return (
        <div className="sm:p-6 p-2 w-full min-h-full" style={{ backgroundColor: "#f5f7fa" }}>
            <Row gutter={[24, 24]}>
                <Col span={24}>
                    <CommonCard
                        title={
                            <div className="flex items-center gap-2">
                                <InfoCircleOutlined
                                    style={{
                                        color: "var(--primary-color, #1890ff)",
                                        fontSize: "clamp(16px, 4vw, 18px)",
                                    }}
                                />
                                <span style={{ fontSize: "clamp(14px, 4vw, 16px)", fontWeight: 600 }}>
                                    Autoresponder Information
                                </span>
                            </div>
                        }
                    >
                        <Row>
                            {[
                                {
                                    label: "Internal Name",
                                    value: data?.name,
                                },
                                {
                                    label: "Display Title",
                                    value: data?.title,
                                }
                            ].map((item, idx) => (
                                <Col
                                    span={24}
                                    key={item.label}
                                    className={cn(
                                        "border-b border-gray-200 py-4",
                                        idx === 1 && "!border-b-0"
                                    )}
                                >
                                    <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center items-start w-full gap-1 sm:gap-2">
                                        <span className="text-sm text-gray-600 flex items-center gap-2 font-medium">
                                            <span
                                                style={{
                                                    color: "var(--primary-color, #1890ff)",
                                                    fontSize: "clamp(14px, 4vw, 16px)",
                                                }}
                                            >
                                                {getIconForField(item.label)}
                                            </span>
                                            {item.label}
                                        </span>
                                        <span className="text-sm font-semibold text-gray-900 break-all sm:break-normal">
                                            {item.value || "—"}
                                        </span>
                                    </div>
                                </Col>
                            ))}
                        </Row>
                    </CommonCard>
                </Col>

                <Col span={24}>
                    <CommonCard
                        title={
                            <div className="flex items-center gap-2">
                                <MessageOutlined
                                    style={{
                                        color: "var(--primary-color, #1890ff)",
                                        fontSize: "clamp(16px, 4vw, 18px)",
                                    }}
                                />
                                <span style={{ fontSize: "clamp(14px, 4vw, 16px)", fontWeight: 600 }}>
                                    Message Content
                                </span>
                            </div>
                        }
                    >
                        <div className="bg-white p-3 sm:p-4 rounded-lg border border-gray-200 min-h-[150px] sm:min-h-[200px]">
                            <div
                                className="prose prose-sm max-w-none text-gray-700 break-words"
                                dangerouslySetInnerHTML={{ __html: data.message }}
                            />
                        </div>
                    </CommonCard>
                </Col>
            </Row>
        </div>
    );
};

export default EnhancedAutorespondersDetails;
